import { FeedbackField } from "../types/feedback.types";

// TODO: state management
const HiddenField = ({ field }: { field: FeedbackField }) => {
  const { defaultValues = {} } = window.__DATA__;
  return (
    <input
      type="hidden"
      name={field._id || field.name}
      value={defaultValues[field._id || field.name] || field.defaultValue}
    />
  );
};
export default HiddenField;
